import React from "react";

import useStyles from "@hooks/useStyles";

import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const { BRAND_NAME } = process.env;

const WebsiteSlider = () => {
	const classes = useStyles("Website");

	const trigger = useScrollTrigger({
		threshold: 1,
		disableHysteresis: true,
	});

	const header = (
		<>
			We've built you a premium website for{" "}
			<span
				style={{
					color: "#4285F4",
					fontWeight: 700,
					fontSize: "120%",
				}}
			>
				F
			</span>
			<span
				style={{
					color: "#EA4335",
					fontWeight: 700,
					fontSize: "120%",
				}}
			>
				R
			</span>
			<span
				style={{
					color: "#34A853",
					fontWeight: 700,
					fontSize: "120%",
				}}
			>
				E
			</span>
			<span
				style={{
					color: "#FBBC05",
					fontWeight: 700,
					fontSize: "120%",
				}}
			>
				E
			</span>
			.
		</>
	);
	const subHeader = `Claim now to increase your bookings and revenue instantly.`;

	const button = "Edit & publish";
	const buttonLink = "/pros";

	return (
		<Slide direction={"down"} in={trigger}>
			<Box
				position={"fixed"}
				p={4}
				left={0}
				right={0}
				top={0}
				width={"100%"}
				bgcolor={"#FFF"}
				zIndex={1200}
				boxShadow={6}
			>
				<Container maxWidth="md">
					<Box
						display={"flex"}
						alignItems={"center"}
						justifyContent={"center"}
						alignContent={"center"}
						flexDirection={{ xs: "column", sm: "row" }}
						flexWrap={"nowrap"}
					>
						<Box
							display={"flex"}
							alignItems={"center"}
							justifyContent={"center"}
							alignContent={"center"}
							mb={{ xs: 4, sm: 0 }}
						>
							<Box
								mr={{ xs: 0, sm: 8 }}
								fontWeight={600}
								fontSize={{ xs: 17, sm: 20 }}
							>
								{header}
								{subHeader && (
									<Box fontWeight={400} mt={1} fontSize={{ xs: 16, sm: 18 }}>
										{subHeader}
									</Box>
								)}
							</Box>
						</Box>
						<Box flex={{ xs: 1, sm: "0 0 200px" }} width={"100%"}>
							<Button
								fullWidth
								href={buttonLink}
								target="_blank"
								size={"large"}
								variant="contained"
								color="primary"
								disableElevation
								endIcon={<ArrowForwardIcon />}
								className="columnButton"
							>
								{button}
							</Button>
						</Box>
					</Box>
				</Container>
			</Box>
		</Slide>
	);
};

export default WebsiteSlider;
